import { Button, ButtonProps, IconMenu } from '@fhs/ui';
import { Link } from '@fhs/link';

export type AccountModalOpenButtonProps = Omit<ButtonProps, 'children'>;

export function AccountModalOpenButton(props: AccountModalOpenButtonProps) {
  return (
    <Link href="/account">
      <Button aria-label="Open account modal" type="ghost" size="xl" {...props}>
        <Button.Icon>
          <IconMenu />
        </Button.Icon>
      </Button>
    </Link>
  );
}
